import React, { useContext } from "react";
import styled from "styled-components";
import axios from "axios";
import Popup from "reactjs-popup";
import { Transaction as EthereumTx } from "ethereumjs-tx";
import Select from "react-select";

import languagePack from "../../../Utils/language";
import { dateConvertor, numberWithCommas, ToFixed } from "../../../Utils/util";
import Theme from "../../../Styles/Theme";
import Button from "../../Common/DefaultButton";
import Logo_HLC from "../../../Resources/Images/coin_hlc.png";
import Logo_HLLC from "../../../Resources/Images/coin_hllc.png";
import customStyles from "../../../Styles/SelectStyle";

import GlobalContext from "../../../Hooks/globalContext";
import {
  HOST,
  CHAIN_ID,
  CHAIN_NAME,
  GAS_PRICE_API,
  NUMBER_REGEX,
  ETHERSCAN_TX_URL,
  ETHERSCAN_ADDRESS_URL,
} from "../../../Utils/constants";
import useState from "../../../Hooks/useState";
import Input from "../../Common/Input";
import useInput from "../../../Hooks/useInput";

const SelectWrapper = styled.div`
  padding: 5px 10px;
  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
`;

const UpdateButton = styled.div`
  color: white;
  padding: 5px;
  border-radius: 5px;
  text-align: center;
  :hover {
    cursor: pointer;
    opacity: 0.75;
  }
  :not(:last-child) {
    margin-right: 5px;
  }
`;

const UpdateLongButton = styled(UpdateButton)`
  width: 100px;
`;

const DeleteButton = styled(UpdateButton)`
  background-color: ${(props) => props.theme.navbar};
`;

const AnotherButton = styled(UpdateButton)`
  background-color: ${(props) => props.theme.mainColor};
`;

const OrangeButton = styled(UpdateButton)`
  background-color: orange;
`;

const DefaultButton = styled(UpdateButton)`
  background-color: ${(props) => props.theme.button};
  width: 70px;
`;

const DeleteForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 18px;
  color: ${(props) => props.theme.black};
`;

const DeleteLabel = styled.div`
  font-size: 20px;
  margin-bottom: 10px;
`;

const RedLabel = styled.span`
  color: red;
`;

const BlueLabel = styled.span`
  color: blue;
`;

const StrongSpan = styled.span`
  font-weight: bold;
`;

const QnaRow = styled.div`
  border-bottom: 1px solid grey;
  padding-bottom: 15px;
  margin-bottom: 15px;
  font-size: 13px;
`;

const BoldText = styled.div`
  font-weight: bold;
`;

const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const OptionSpan = styled.span`
  margin-left: 5px;
`;

const ColumnFactory = (params) => {
  const { httpHeader, modal, web3, getTxCount, getBalance, user, language } = useContext(GlobalContext);
  const defaultValue = useState(null);
  const selected = useState(null);
  const lockAmount = useInput({ defaultValue: "", maxLength: 15, regex: NUMBER_REGEX });
  const lockDay = useInput({ defaultValue: "", maxLength: 15, regex: NUMBER_REGEX });
  const chargePoint = useInput({ defaultValue: "", maxLength: 15 });

  const options = () => {
    return [
      {
        value: "hlc",
        label: (
          <OptionWrapper>
            <img src={Logo_HLC} style={{ width: 16, height: 16 }} />
            <OptionSpan>HLC</OptionSpan>
          </OptionWrapper>
        ),
      },
      {
        value: "hllc",
        label: (
          <OptionWrapper>
            <img src={Logo_HLLC} style={{ width: 16, height: 16 }} />
            <OptionSpan>HLLC</OptionSpan>
          </OptionWrapper>
        ),
      },
    ];
  };

  const handleChange = ({ value }) => {
    const LabelHLC = () => (
      <OptionWrapper>
        <img src={Logo_HLC} style={{ width: 16, height: 16 }} />
        <OptionSpan>HLC</OptionSpan>
      </OptionWrapper>
    );

    const LabelHLLC = () => (
      <OptionWrapper>
        <img src={Logo_HLLC} style={{ width: 16, height: 16 }} />
        <OptionSpan>HLLC</OptionSpan>
      </OptionWrapper>
    );

    switch (value) {
      case "hlc":
        defaultValue.setState({
          value,
          label: <LabelHLC />,
        });
        break;
      case "hllc":
        defaultValue.setState({
          value,
          label: <LabelHLLC />,
        });
        break;
    }

    selected.setState(value);
  };

  return {
    user: [
      {
        title: languagePack("번호", language.state),
        dataIndex: "id",
        key: "id",
      },
      {
        title: "ID",
        dataIndex: "account",
        key: "account",
      },
      {
        title: languagePack("이메일", language.state),
        dataIndex: "email",
        key: "email",
        render: (item) => {
          return <>{item ? item : "-"}</>;
        },
      },
      {
        title: "지갑주소",
        dataIndex: "wallet_address",
        key: "wallet_address",
        render: (item) => {
          return (
            <DefaultButton
              onClick={() => {
                window.open(`${ETHERSCAN_ADDRESS_URL}${item}`);
              }}
            >
              확인
            </DefaultButton>
          );
        },
      },
      {
        title: languagePack("가입일", language.state),
        dataIndex: "created_at",
        key: "created_at",
        render: (item) => {
          return <>{dateConvertor(new Date(item))}</>;
        },
      },
      {
        title: languagePack("이메일인증여부", language.state),
        dataIndex: "email_confirmed",
        key: "email_confirmed",
        render: (item) => {
          return <>{item === 0 ? "X" : "O"}</>;
        },
      },
      {
        title: "락업된 HLC",
        dataIndex: "locked_amount_hlc",
        key: "locked_amount_hlc",
        render: (item) => <>{numberWithCommas(Number(item))} HLC</>,
      },
      {
        title: "락업된 HLLC",
        dataIndex: "locked_amount_hllc",
        key: "locked_amount_hllc",
        render: (item) => <>{numberWithCommas(Number(item))} HLLC</>,
      },
      {
        title: languagePack("관리", language.state),
        render: (item) => {
          const deleteOnClick = async (close) => {
            const requestBody = {
              userId: item.id,
              action: "delete",
            };
            const { data } = await axios.post(`${HOST}/admin/users/crud`, requestBody, httpHeader());
            close();
            params.reset({ selected: params.nowPage.state });
          };

          const lockOnClick = async (close) => {
            if (lockAmount.value === "" || lockDay.value === "") {
              modal.setState("입력값이 없습니다.");
              return;
            }

            if (isNaN(Number(lockAmount.value)) || isNaN(Number(lockDay.value))) {
              modal.setState("숫자를 입력해주세요.");
              return;
            }

            if (!selected.state) {
              modal.setState("락업할 토큰 타입을 선택해주세요.");
              return;
            }

            const requestBody = {
              userId: item.id,
              tokenType: selected.state,
              amount: Number(lockAmount.value),
              day: Number(lockDay.value),
            };

            const { data } = await axios.post(`${HOST}/admin/users/lock`, requestBody, httpHeader());
            if (data.status) {
              close();
              lockAmount.setValue("");
              lockDay.setValue("");
              params.reset({ selected: params.nowPage.state });
              modal.setState("락업이 완료되었습니다.");
            }
          };

          return (
            <ButtonWrapper>
              {user.state.is_admin === 1 && (
                <>
                  <Popup
                    trigger={<OrangeButton>{languagePack("락업", language.state)}</OrangeButton>}
                    modal={true}
                    contentStyle={{
                      padding: 25,
                      width: 300,
                      border: 0,
                      borderRadius: 10,
                    }}
                  >
                    {(close) => (
                      <DeleteForm>
                        <SelectWrapper>
                          <Select
                            defaultValue={defaultValue.state}
                            onChange={handleChange}
                            isClearable={false}
                            isSearchable={false}
                            styles={customStyles}
                            placeholder={"락업할 토큰"}
                            options={options({ level: user.state.admin_level })}
                          />
                        </SelectWrapper>

                        <Input
                          placeholder={languagePack("락업 갯수", language.state)}
                          style={{ marginBottom: 10, color: "black", backgroundColor: "white" }}
                          {...lockAmount}
                        />
                        <Input
                          placeholder={languagePack("락업 시간 (일 단위)", language.state)}
                          style={{ marginBottom: 10, color: "black", backgroundColor: "white" }}
                          {...lockDay}
                        />
                        <Button
                          onClick={lockOnClick.bind(null, close)}
                          text={languagePack("락업", language.state)}
                          style={{ padding: "10px 15px", backgroundColor: Theme.mainColor }}
                        />
                      </DeleteForm>
                    )}
                  </Popup>
                  <Popup
                    trigger={<DeleteButton>{languagePack("삭제", language.state)}</DeleteButton>}
                    modal={true}
                    contentStyle={{
                      padding: 25,
                      width: 300,
                      border: 0,
                      borderRadius: 10,
                    }}
                  >
                    {(close) => (
                      <DeleteForm>
                        <DeleteLabel>{languagePack("정말 삭제하시겠습니까?", language.state)}</DeleteLabel>
                        <Button
                          onClick={deleteOnClick.bind(null, close)}
                          text={languagePack("삭제", language.state)}
                          style={{ padding: "10px 15px" }}
                        />
                      </DeleteForm>
                    )}
                  </Popup>
                </>
              )}
            </ButtonWrapper>
          );
        },
      },
    ],
    lockupList: [
      {
        title: "번호",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "락업 갯수",
        dataIndex: "locked_amount",
        key: "locked_amount",
        render: (item) => {
          return <>{Number(item)}</>;
        },
      },
      {
        title: "토큰 타입",
        dataIndex: "token_type",
        key: "token_type",
      },
      {
        title: "날짜",
        dataIndex: "created_at",
        key: "created_at",
        render: (item) => {
          return <>{item ? dateConvertor(new Date(item)) : "-"}</>;
        },
      },
      {
        title: "강제 해제상태",
        dataIndex: "status",
        key: "status",
        render: (item) => {
          return <>{item === 0 ? "-" : <RedLabel>강제 해제됨</RedLabel>}</>;
        },
      },
      {
        title: "락업 해제일",
        dataIndex: "release_time",
        key: "release_time",
        render: (item) => {
          return <>{item ? dateConvertor(new Date(item)) : "-"}</>;
        },
      },
      {
        title: "유저 번호",
        dataIndex: "user_id",
        key: "user_id",
      },
      {
        title: "관리",
        render: (item) => {
          const toggle = async () => {
            const requestBody = {
              id: item.id,
              toggle: item.status,
            };
            const { data } = await axios.post(`${HOST}/admin/lockup/toggle`, requestBody, httpHeader());

            params.reset({ selected: params.nowPage.state });
          };

          return (
            <ButtonWrapper>
              {item.status === 0 ? (
                <OrangeButton onClick={toggle} style={{ width: "auto" }}>
                  락업 강제 해제
                </OrangeButton>
              ) : (
                <DeleteButton onClick={toggle} style={{ width: "auto" }}>
                  재 락업
                </DeleteButton>
              )}
            </ButtonWrapper>
          );
        },
      },
    ],
    notice: [
      {
        title: "번호",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "제목",
        dataIndex: "title",
        key: "title",
      },
      {
        title: "날짜",
        dataIndex: "created_at",
        key: "created_at",
      },
      {
        title: "관리",
        render: (item) => {
          const updateOnClick = () => {
            params.focus.setState(item);
            params.page.setState("noticeUpdate");
          };

          const deleteOnClick = async (close) => {
            const requestBody = {
              id: item.id,
              action: "delete",
            };
            const { data } = await axios.post(`${HOST}/admin/notice/crud`, requestBody, httpHeader());
            close();
            params.reset({ selected: 0, init: true });
          };

          const noticeOnClick = async () => {
            const requestBody = {
              id: item.id,
              toggle: item.check,
            };
            const { data } = await axios.post(`${HOST}/admin/notice/toggle`, requestBody, httpHeader());
            if (data.status) {
              params.reset({ selected: 0, init: true });
            } else {
              modal.setState("이미 메인공지가 있습니다. 기존의 공지를 해제한 뒤 다시 시도해주세요.");
            }
          };

          return (
            <ButtonWrapper>
              {item.check === "Y" ? (
                <OrangeButton style={{ backgroundColor: "skyblue" }} onClick={noticeOnClick}>
                  메인 공지 해제
                </OrangeButton>
              ) : (
                <OrangeButton style={{ backgroundColor: "blue" }} onClick={noticeOnClick}>
                  메인 공지 지정
                </OrangeButton>
              )}

              <OrangeButton onClick={updateOnClick}>수정</OrangeButton>
              <Popup
                trigger={<DeleteButton>삭제</DeleteButton>}
                modal={true}
                contentStyle={{
                  padding: 25,
                  width: 300,
                  border: 0,
                  borderRadius: 10,
                }}
              >
                {(close) => (
                  <DeleteForm>
                    <DeleteLabel>정말 삭제하시겠습니까?</DeleteLabel>
                    <Button onClick={deleteOnClick.bind(null, close)} text="삭제" style={{ padding: "10px 15px" }} />
                  </DeleteForm>
                )}
              </Popup>
            </ButtonWrapper>
          );
        },
      },
    ],
  };
};

export default ColumnFactory;
